exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Example Media queries\n *\n * @media (max-width: @kng-screen-xs-max) { ... }\n * @media (min-width: @kng-screen-sm-min) and (max-width: @kng-screen-sm-max) { ... }\n * @media (min-width: @kng-screen-md-min) and (max-width: @kng-screen-md-max) { ... }\n * @media (min-width: @kng-screen-lg-min) { ... }\n *\n */\n.status-label {\n  background-color: #a1afc0;\n  padding: 5px 10px 5px 10px;\n  font-size: 10px;\n  font-weight: 800;\n  text-transform: uppercase;\n  border-radius: 15px;\n  height: 24px;\n}\n.status-label.active {\n  background-color: #6fa623;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/components/common/statusLabel/statusLabel.component.less
// module id = ../../../../../src/app/components/common/statusLabel/statusLabel.component.less
// module chunks = main